import React, { memo } from 'react';
import { RadioGroupProps } from 'formik-mui';
import { Styled } from './fancy-radio.styled';

interface FancyRadioGroupProps extends RadioGroupProps {
    onClick?: () => void;
}

const FancyRadioGroup: React.FC<FancyRadioGroupProps> = memo(
    ({ children, ...props }) => {
        const {
            form: { setFieldValue },
            field: { name },
            onClick,
        } = props;

        const onChange: any = React.useCallback(
            (event: any) => {
                onClick && onClick();
                setFieldValue(name, event.target.value);
            },
            [setFieldValue, name],
        );

        return (
            <Styled.RadioGroup {...props} onChange={onChange}>
                {children}
            </Styled.RadioGroup>
        );
    },
);

export { FancyRadioGroup };
